import SingleSpecs from "./SingleSpecs";

export default function ProductSpecs({selectedVariant}) {

    const setupProductSpecs = () => {
        let specs = [];

        if (
            selectedVariant?.oorsprong ||
            selectedVariant?.kroon ||
            selectedVariant?.hoogte ||
            selectedVariant?.winterhardheid
        ) {
            specs.push({
                label: "Eigenschappen",
                rows: [
                    {
                        label: "Oorsprong",
                        specData: [
                            {
                                label: selectedVariant?.product?.greenProperties?.oorsprong,
                            },
                        ],
                    },
                    {
                        label: "Kroon",
                        specData: [
                            {
                                label: selectedVariant?.kroon,
                            },
                        ],
                    },
                    {
                        label: "Afmeting",
                        specData: [
                            {
                                label: selectedVariant?.hoogte
                                    ? selectedVariant?.hoogte + " hoog"
                                    : "",
                            },
                        ],
                    },
                    {
                        label: "Winterhardheidszone",
                        specData: [
                            {
                                label: selectedVariant?.winterhardheid,
                            },
                        ],
                    },
                ],
            });
        }

        if (
            selectedVariant?.toepassing ||
            selectedVariant?.plaatsLocatie ||
            selectedVariant?.plantafstand ||
            selectedVariant?.plantenPerM2
        ) {
            specs.push({
                label: "Toepassing",
                rows: [
                    {
                        label: "Locatie",
                        specData: [
                            {
                                label: selectedVariant?.toepassing,
                                splitBy: ", ",
                            },
                        ],
                    },
                    {
                        label: "Plaats locatie",
                        specData: [
                            {
                                label: selectedVariant?.plaatsLocatie,
                            },
                        ],
                    },
                    {
                        label: "Planten per m2",
                        specData: [
                            {
                                label: selectedVariant?.plantafstand,
                            },
                        ],
                    },
                    {
                        label: "Planten per m2",
                        specData: [
                            {
                                label: selectedVariant?.plantenPerM2,
                            },
                        ],
                    },
                ],
            });
        }

        if (
            selectedVariant?.grondsoort ||
            selectedVariant?.bodemvochtigheid ||
            selectedVariant?.standplaats ||
            selectedVariant?.giftigheid ||
            selectedVariant?.bestandheid
        ) {
            specs.push({
                label: "Standplaats",
                rows: [
                    {
                        label: "Grondsoort",
                        specData: [
                            {
                                label: selectedVariant?.grondsoort,
                            },
                        ],
                    },
                    {
                        label: "Bodemvochtigheid",
                        specData: [
                            {
                                label: selectedVariant?.bodemvochtigheid,
                            },
                        ],
                    },
                    {
                        label: "Lichtbehoefte",
                        specData: [
                            {
                                label: selectedVariant?.standplaats,
                            },
                        ],
                    },
                    {
                        label: "PH-waarde",
                        specData: [
                            {
                                label: selectedVariant?.giftigheid,
                            },
                        ],
                    },
                    {
                        label: "Bestandheid",
                        specData: [
                            {
                                label: selectedVariant?.bestandheid,
                            },
                        ],
                    },
                ],
            });
        }

        if (
            selectedVariant?.bloemen ||
            selectedVariant?.blad1 ||
            selectedVariant?.vruchten1 ||
            selectedVariant?.stekels ||
            selectedVariant?.schorsEnTakken ||
            selectedVariant?.kleur ||
            selectedVariant?.groenverliezend
        ) {
            specs.push({
                label: "Plantkenmerken",
                rows: [
                    {
                        label: "Bloem",
                        specData: [
                            {
                                label: selectedVariant?.bloemen,
                            },
                        ],
                    },
                    {
                        label: "Blad",
                        specData: [
                            {
                                label: selectedVariant?.blad1,
                            },
                        ],
                    },
                    {
                        label: "Vrucht",
                        specData: [
                            {
                                label: selectedVariant?.vruchten1,
                            },
                        ],
                    },
                    {
                        label: "Stekels",
                        specData: [
                            {
                                label: selectedVariant?.stekels,
                            },
                        ],
                    },
                    {
                        label: "Tak",
                        specData: [
                            {
                                label: selectedVariant?.schorsEnTakken,
                            },
                        ],
                    },
                    {
                        label: "Kleur",
                        specData: [
                            {
                                label: selectedVariant?.kleur,
                            },
                        ],
                    },
                    {
                        label: "Groenverliezend",
                        specData: [
                            {
                                label: selectedVariant?.groenverliezend,
                            },
                        ],
                    },
                ],
            });
        }

        return specs;
    };
    const productSpecs = setupProductSpecs();


    return (<div className="flex flex-col lg:grid lg:grid-cols-12 lg:gap-8 mt-8">
            {productSpecs.map(({ label, rows }, i) => {
                return <SingleSpecs key={label} label={label} data={rows} />;
                })}
</div>);
}